import controller from './toolbox.controller';
import template from './toolbox.html';

export default {
    controller,
    template,
    bindings: {
        widget: '@'
    }
}


// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/toolbox/toolbox.component.js